import { appActions } from '@app';
import { createSonarSelector } from '@lib/selectors';
import { useAction } from './useAction';
import { useCallback } from 'react';
import { useSonarSelector } from './useSonarSelector';
const selector = createSonarSelector((state) => { var _a; return Boolean((_a = state.application.sidebar.read.data) === null || _a === void 0 ? void 0 : _a.closed); });
export function useApplicationSidebar() {
    const isClosed = useSonarSelector(selector);
    const update = useAction(appActions.updateApplicationSidebar);
    const close = useCallback(() => {
        update({
            closed: true
        });
    }, [update]);
    const open = useCallback(() => {
        update({
            closed: false
        });
    }, [update]);
    const toggle = useCallback(() => {
        update({
            closed: !isClosed
        });
    }, [isClosed, update]);
    return {
        close,
        isClosed,
        open,
        toggle
    };
}
